import { apiStage } from '@/plugins/axios'
// import axios from 'axios'
import Rest from '../rest'


/******************************************************************************
 * Reports Category
 *****************************************************************************/

/**
 * @type {ReportsCategory}
 */
export default class ReportsCategory extends Rest {

    constructor (endpoint = 'reports') {
        super(endpoint)
        this.http = apiStage
    }

    async defineVersionReports(instance) {
        // Faz a requisição para obter as instancias das empresas que não podem usar o Data Lake ( devido ao volume de dados )
        const response = await fetch('https://gs-directory-files-production.s3.amazonaws.com/cloud_system_resources/instances_resources.json')
        const data = await response.json()

        // Determine o valor do endpoint baseado na resposta
        const endpoint = data.withoutInstances.includes(instance) ? 'reports' : 'reports-datalake'

        // Crie uma nova instância da classe com o endpoint determinado
        return new ReportsCategory(endpoint)
    }

    async getWithoutInstances() {
        const response = await fetch('https://gs-directory-files-production.s3.amazonaws.com/cloud_system_resources/instances_resources.json')
        return response.json()
    }
}

